import React from 'react'
import { Link2 } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'
import TaskTypeIcon from './TaskTypeIcon'

const TaskDisplayId = ({ projectKey, taskNumber, taskType, size = 'sm' }) => {
  if (!projectKey || !taskNumber) return null

  const displayId = `${projectKey}-${taskNumber}`

  const handleCopy = (e) => {
    e.stopPropagation()
    e.preventDefault()
    // Key-based link (/browse/PC-42) — stable and readable, like Jira's
    const url = `${window.location.origin}/browse/${displayId}`
    navigator.clipboard.writeText(url).then(() => {
      toast.success('Link copied')
    })
  }

  return (
    <span className={cn(
      'inline-flex items-center gap-1 font-mono text-muted-foreground group/tid shrink-0',
      size === 'md' ? 'text-sm font-medium' : 'text-[11px]'
    )}>
      {taskType && <TaskTypeIcon type={taskType} size={size} />}
      {displayId}
      <button
        type="button"
        onClick={handleCopy}
        className="opacity-0 group-hover/tid:opacity-100 transition-opacity hover:text-foreground"
        title="Copy link"
      >
        <Link2 className={cn(size === 'md' ? 'h-3.5 w-3.5' : 'h-3 w-3')} />
      </button>
    </span>
  )
}

export default TaskDisplayId
